module.exports = __webpack_public_path__ + "images/icon/report_btn_ppt-5544f18a.svg";